import React, { useEffect, useState } from 'react';
import { Form, Input, Button, message, Row, Col } from 'antd';
import axios from 'axios';

const CommissionForm = ({ formData, setFormData, closeModal, setSubmitted }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [formData, form]);

  const onFinish = async (values) => {
    try {
      const token = localStorage.getItem('token'); // Get the token from local storage
      let response;
  
      if (formData.id) {
        // Update commission
        response = await axios.put(`http://93.127.203.113:5005/commissions/${formData.id}`, values, {
          headers: {
            Authorization: `Bearer ${token}` // Include token if required
          }
        });
      } else {
        // Add new commission
        response = await axios.post('http://93.127.203.113:5005/commissions', values, {
          headers: {
            Authorization: `Bearer ${token}` // Include token if required
          }
        });
      }
  
      if (response.status === 200) {
        message.success('Commission saved successfully');
        setFormData({});
        closeModal();
        setSubmitted(true); // Trigger refetch after successful form submission
      } else {
        throw new Error('Unexpected response');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Failed to save commission');
    }
  };
  

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please enter the commission name' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Percentage" name="percentage" rules={[{ required: true, message: 'Please enter the percentage' }]}>
            <Input type="number" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item label="Status" name="status" rules={[{ required: true, message: 'Please enter the status' }]}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Save
        </Button>
        <Button htmlType="button" onClick={() => form.resetFields()}>
          Reset
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CommissionForm;
